import styled from 'styled-components';

export const PlayVideoContent = styled.div`
  opacity: 0;
  transition: opacity 0.25s ease;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

PlayVideoContent.displayName = 'PlayVideoContent';
